import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import PhoneNumber from './phone_number';

export default class PhoneNumbers extends React.Component {
  static propTypes = {
    labels: PropTypes.array.isRequired,
    phoneNumbers: PropTypes.arrayOf(PropTypes.shape({
      _destroy: PropTypes.bool
    })).isRequired,
    onChange: PropTypes.func.isRequired
  }

  get phoneNumbers() {
    return this.props.phoneNumbers.filter(phoneNumber => !phoneNumber._destroy);
  }

  handleAdd = () => {
    this.props.onChange([...this.props.phoneNumbers, {
      index: this.props.phoneNumbers.length,
      label: this.props.labels[0]
    }]);
  }

  handleChange = (changes, phoneNumber) => {
    const phoneNumbers = [...this.props.phoneNumbers];

    if (changes.primary) {
      for (const index in phoneNumbers) {
        phoneNumbers[index] = { ...phoneNumbers[index], primary: false };
      }
    }

    phoneNumbers[phoneNumber.index] = { ...phoneNumbers[phoneNumber.index], ...changes };
    this.props.onChange(phoneNumbers);
  }

  render() {
    return <React.Fragment>
      {this.phoneNumbers.map(phoneNumber => (
        <PhoneNumber
          key={phoneNumber.index}
          labels={this.props.labels}
          phoneNumber={phoneNumber}
          onChange={this.handleChange}
        />
      ))}

      <AddControl className="mx-4" name="add-phone-number" onClick={this.handleAdd}>
        Add another phone/fax
      </AddControl>
    </React.Fragment>;
  }
}
